import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';
import { ChartCard, ChartEmpty } from './ChartCard';

interface Point { time: string; price: number | null; }
interface Props {
  kospi: Point[];
  kosdaq: Point[];
  /** X축 종료시점 — 장중 브리핑은 '15:00', 국장 마감은 '15:30'. 기본 '15:30'. */
  endTime?: '15:00' | '15:30';
}

const fmtIndex = (v: number) => v.toLocaleString('ko-KR', { maximumFractionDigits: 2 });

/** 09:00 ~ endTime 까지의 정시 라벨 + 마감 라벨 생성. */
function buildTicks(endTime: '15:00' | '15:30'): string[] {
  const [endH, endM] = endTime.split(':').map(Number);
  const ticks: string[] = [];
  for (let h = 9; h <= endH; h++) {
    ticks.push(`${String(h).padStart(2, '0')}:00`);
  }
  if (endM !== 0) ticks.push(endTime);
  return ticks;
}

function MiniLine({ data, color, ticks }: { data: Point[]; color: string; ticks: string[] }) {
  if (data.length === 0) return <ChartEmpty />;
  return (
    <ResponsiveContainer width="100%" height={220}>
      <LineChart data={data} margin={{ top: 6, right: 12, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
        <XAxis
          dataKey="time"
          tick={{ fontSize: 10 }}
          ticks={ticks}
          interval={0}
        />
        <YAxis
          domain={['auto', 'auto']}
          allowDataOverflow={false}
          tick={{ fontSize: 11 }}
          tickFormatter={fmtIndex}
          width={80}
        />
        <Tooltip
          formatter={(value: number) => [fmtIndex(value), '지수']}
          labelFormatter={(label: string) => `시간 ${label}`}
        />
        <Line
          type="monotone"
          dataKey="price"
          stroke={color}
          strokeWidth={2}
          dot={false}
          connectNulls={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}

/** 국장 마감 / 장중 브리핑 — KOSPI/KOSDAQ 당일 5분봉.
 *  X축은 09:00 ~ endTime KST 고정 윈도우, 정시 라벨 표시. */
export function KrCloseChart({ kospi, kosdaq, endTime = '15:30' }: Props) {
  const ticks = buildTicks(endTime);
  return (
    <div className="grid gap-4 md:grid-cols-2">
      <ChartCard title="KOSPI" subtitle="당일 5분봉">
        <MiniLine data={kospi} color="#ef4444" ticks={ticks} />
      </ChartCard>
      <ChartCard title="KOSDAQ" subtitle="당일 5분봉">
        <MiniLine data={kosdaq} color="#0284c7" ticks={ticks} />
      </ChartCard>
    </div>
  );
}
